import { qdfoodApi } from './constant';
import { IDocument } from '@type/document';

export const DOCUMENT_API = {
  urlGetDocument: `/document/list`,
};

export default class documentApi {
  static getDocument() {
    return qdfoodApi().get<IDocument[]>(DOCUMENT_API.urlGetDocument, {
      params: {
        isDeleted: false,
        sort: 'createdAt',
        order: 'asc',
      },
    });
  }
}
